<template>
  <div class='EnbLogo02'>
    <img :src="Logo">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'EnbLogo02',
  computed : {
    ...mapGetters(['Logo'])
  }
}
</script>

<style scoped>
.EnbLogo02 {
  width: 12%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 90%;
  height: 90%;
  cursor: pointer;
}
</style>
